import React, { useRef, useState } from "react"
import { mutate } from "swr"
import { OrderApi, RequestOrderCreateOne } from "../../libs/api/backend/src"
import { createConfiguration } from "../../libs/api/openApi"
import { useMainEnterpriseId } from "../../hooks/enterprise"
import { UrlOrderFindListAPI } from "../../libs/api/url"
import { useShopId } from "../../hooks/shop"
import OrderModalCreate from "./OrderModalCreate"
import { useLimit, useOffset } from "../../hooks/pagination"
import { useShopSalePointId } from "../../hooks/shopSalePoint"

const ItemHeadLine = ({}) => {
  const clientAPI = new OrderApi(createConfiguration())

  const enterpriseId = useMainEnterpriseId()
  const shopId = useShopId()
  const shopSalePointId = useShopSalePointId()
  const limit = useLimit()
  const offset = useOffset()

  const [isOpen, setIsOpen] = useState(false)
  const cancelButtonRef = useRef(null)

  const openCloseModal = () => {
    setIsOpen(!isOpen)
  }

  const onSubmit = async (values: RequestOrderCreateOne, { setSubmitting }) => {
    try {
      // Create sale
      const { success } = await clientAPI.orderCreateOne({
        enterpriseId: enterpriseId,
        requestOrderCreateOne: {
          typeOrder: values.typeOrder,
          reason: values.reason,
          sum: values.sum,
          sourceType: values.sourceType,
          sourceId: values.sourceId,
          shopId: values.shopId,
          shopSalePointId: values.shopSalePointId,
          shopPaymentPointId: values.shopPaymentPointId,
          parentId: values.parentId,
        },
      })

      if (!success) {
        return
      }

      await mutate(
        UrlOrderFindListAPI(enterpriseId, {
          shopId,
          shopSalePointId,
          limit,
          offset,
        })
      )

      openCloseModal()
    } catch (error) {
      console.error(error)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="sm:flex sm:items-center">
      <div className="sm:flex-auto">
        <h1 className="text-xl font-semibold text-gray-900">Кассовые ордера</h1>
        <p className="mt-2 text-sm text-gray-700">
          Список кассовых ордеров в магазине
        </p>
      </div>

      <div className="mt-5 flex flex-col sm:flex-row lg:mt-0 lg:ml-4">
        <span className="mt-3 sm:mt-0 sm:ml-3">
          <button
            type="button"
            onClick={openCloseModal}
            className="inline-flex w-full items-center justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none sm:w-auto"
          >
            Добавить кассовый ордер
          </button>
        </span>
      </div>

      <OrderModalCreate
        isOpen={isOpen}
        setOpen={openCloseModal}
        cancelButtonRef={cancelButtonRef}
        onCancel={openCloseModal}
        onSubmit={onSubmit}
      />
    </div>
  )
}

export default ItemHeadLine
